export default from './PixelMap';

